export const APP_CONFIG = {
    emailJs: {
        publicKey: 'lSus7ooCGADT2xhQP',
        service: 'service_rk1pnwk',
        contact_template: 'template_ncqqdi3',
        ftcf_template: 'template_ncqqdi3'
    },
    phoneLink: 'tel:+16478556177',
    phone: '+1(647)855-6177',
    email: 'info@orientalbiz.ca',
    emailLink: 'mailto:info@orientalbiz.ca',
    address: 'Unit 201, 2970 Drew Road, Mississauga, ON L4T 0A6',
    address2line: 'Unit 201, 2970 Drew Road, Mississauga, ON L4T 0A6',
    addressLink: 'https://www.google.com/maps?q=Unit+201,+2970+Drew+Road+Mississauga,+ON+L4T+0A6',
    gmapLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2884.036010677325!2d-79.6534211!3d43.709800699999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3c06f8a7a459%3A0x443a394e6ea128b8!2s2970%20Drew%20Rd%20Unit%20201%2C%20Mississauga%2C%20ON%20L4T%200A6%2C%20Canada!5e0!3m2!1sen!2sin!4v1761634014053!5m2!1sen!2sin',
    whatsAppLink: `https://wa.me/+16478556177?text=${encodeURIComponent("Hello, I'm interested in your services. Could you please let me know your available times to connect? Thank you!")}`,
    facebookLink: "https://www.facebook.com/oriental2022?mibextid=LQQJ4d",
    instaLink: "https://www.instagram.com/orientalbusinesssolutions?igsh=MTVyczU5MHpiajgydQ==",
    linkedInLink: "https://www.linkedin.com/in/orientalbusiness",

}
